
import React, { Fragment, useEffect, useState } from 'react'
import { plural, trans } from '../../../_providers/Translation'
import { Table, TableBody, TableCell, TableContainer, TableHead, Paper, TextField, Select, MenuItem, InputAdornment, Avatar, LinearProgress, Typography, Box, IconButton, Tooltip } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import NoDataFound from '../../partials/NoDataFound'
import Options from './partials/Options'
import Api from '../../../_helpers/Api'
import DateRange from '@/components/partials/DateRange'
import Skeleton from 'react-loading-skeleton'
import { useHistory, useLocation } from 'react-router'


let timeout = null
function BonusPolicyTypesTab({
    handleEdit,
    handleDelete,
    handleShowPeriods,
    update
}) {
    const [dateRange, setDateRange] = React.useState({ start: null, end: null })
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(false)
    const [periods, setPeriods] = useState([])
    const [periodsLoading, setPeriodsLoading] = useState(true)
    const [selectedPeriod, setSelectedPeriod] = useState(null)
    const [periodResults, setPeriodResults] = useState(null)
    const [typeFilter, setTypeFilter] = useState('')
    const [searchFilter, setSearchFilter] = useState('')
    const [completedTargetFilter, setCompletedTargetFilter] = useState('')
    const [filters, setFilters] = useState(false)

    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const selected = searchParams.get('id') ? Number(searchParams.get('id')) : null


    // Fetch all periods when filters change
    useEffect(() => {
        setPeriodsLoading(true)
        // Build params from filters
        const params = {}
        if (typeFilter) params.type = typeFilter
        if (completedTargetFilter) params.completed_target = completedTargetFilter
        if (dateRange.start) params.from = dateRange.start
        if (dateRange.end) params.to = dateRange.end
        if (searchFilter) params.search = searchFilter

        // Update URL params
        const url = new URL(window.location.href)
        Object.keys(params).forEach(key => {
            if (params[key]) {
                url.searchParams.set(key, params[key])
            } else {
                url.searchParams.delete(key)
            }
        })
        window.history.replaceState({}, '', url)

        Api.get('partners/bonuspolicies/all-periods', { params })
            .then(res => {
                // Defensive: ensure array for all possible API shapes
                let periodsArr = []
                if (Array.isArray(res.data)) {
                    periodsArr = res.data
                } else if (res.data && Array.isArray(res.data.periods)) {
                    periodsArr = res.data.periods
                } else if (res.data && Array.isArray(res.data.items)) {
                    periodsArr = res.data.items
                }
                setPeriods(periodsArr)
            })
            .finally(() => setPeriodsLoading(false))
    }, [typeFilter, completedTargetFilter, dateRange.start, dateRange.end, update, filters])

    // Fetch employees progress for selected period
    useEffect(() => {
        if (!selectedPeriod) return
        setLoading(true)
        setPeriodResults(null)
        Api.get('partners/bonuspolicies/prediction', {
            params: {
                period_id: selectedPeriod.id,
                policy_id: selectedPeriod.policy_id
            }
        })
            .then(res => {
                // For type_id=1, sometimes technicians are directly in res.data.technicians
                let allTechs = []
                if (res.data.active_policies && Array.isArray(res.data.active_policies)) {
                    allTechs = res.data.active_policies.flatMap(policy =>
                        (policy.technicians || []).map(tech => ({
                            ...tech,
                            policy_id: policy.policy_id,
                            policy_type: policy.policy_type,
                            policy_from: policy.from,
                            policy_to: policy.to
                        }))
                    )
                }
                // If no active_policies or empty, fallback to res.data.technicians
                if ((!allTechs || allTechs.length === 0) && Array.isArray(res.data.technicians)) {
                    allTechs = res.data.technicians
                }
                setRows(allTechs)
                // Save results if present
                if (res.data && res.data.results) {
                    setPeriodResults(res.data.results)
                } else {
                    setPeriodResults(null)
                }
            })
            .finally(() => setLoading(false))
    }, [selectedPeriod])

    const handleStartDateChange = date => setDateRange(prev => ({ ...prev, start: date }))
    const handleEndDateChange = date => setDateRange(prev => ({ ...prev, end: date }))

    // Handler to clear all filters
    const handleClearFilters = () => {
        setTypeFilter('')
        setCompletedTargetFilter('')
        setDateRange({ start: null, end: null })
        setSearchFilter('')
        setFilters(new Date().getTime())
    }

    const handleToggleRow = rowId => {

        document.querySelectorAll('.collapsable-table tr.active').forEach(el => {
            el.classList.remove('active')
        })

        let rows = document.querySelectorAll(`tr[data-row="${rowId}"]`)

        for (let i = 0; i < rows.length; i++) {
            if (rows[i].classList.contains('active')) {
                rows[i].classList.remove('active')
            } else {
                rows[i].classList.add('active')
            }
        }

        searchParams.set('id', rowId)

        history.replace('?' + searchParams.toString())

    }

    function handleSearch(e) {
        clearTimeout(timeout)
        setSearchFilter(e.target.value)

        timeout = setTimeout(() => {
            setFilters(new Date().getTime())
        }, 300)

    }

    function getRepeatPeriod(period, repeatAfter) {
        switch (period) {
            case 1:
                return plural('plural_periods.day', repeatAfter || 1)
            case 2:
                return plural('plural_periods.week', repeatAfter || 1)
            case 3:
                return plural('plural_periods.month', repeatAfter || 1)
            case 4:
                return plural('plural_periods.year', repeatAfter || 1)

            default:
                return ''
        }
    }

    return (
        <>
            <h3>{trans('headings.bonusPoliciesList')}</h3>
            <div className='filter-standard'>
                <div className='col'>
                    <input
                        id="search"
                        type="search"
                        name="name"
                        value={searchFilter}
                        onChange={handleSearch}
                        placeholder={trans('labels.search')}
                    />
                </div>
                <div className='col'>
                    <select
                        value={typeFilter}
                        onChange={e => setTypeFilter(e.target.value)}
                    >
                        <option value="">{trans('labels.type') || 'Тип'}</option>
                        <option value={1}>{trans('labels.policyByPoints') || 'По точки'}</option>
                        <option value={2}>{trans('labels.policyByReservations') || 'По резервации'}</option>
                    </select>
                </div>
                <div className='col'>
                    <DateRange
                        startDate={dateRange.start}
                        endDate={dateRange.end}
                        onStartDateChange={(date) => {
                            handleStartDateChange(date)
                        }} onEndDateChange={(date) => {
                            handleEndDateChange(date)
                        }}
                    />
                </div>
                <div className='col'>
                    <button className='button-clear-filter' onClick={handleClearFilters}>
                        {trans('buttons.clearFilter')}
                    </button>
                </div>
            </div>
            <hr />

            {periodsLoading ? (
                <Skeleton height={45} count={5} />
            ) : periods.length === 0 ? (
                <NoDataFound />
            ) : (
                <table className="collapsable-table">
                    <thead>
                        <tr>
                            <th>{trans('labels.type')}</th>
                            <th>{trans('labels.from')}</th>
                            <th>{trans('labels.to')}</th>
                            <th>{trans('labels.period')}</th>
                            <th className="options">{trans('labels.options')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {periods.map(period => (
                            <Fragment key={'partner-' + period.id}>
                                <tr
                                    className={period.id === selected ? 'active' : ''}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        handleToggleRow(period.id)

                                        if (selectedPeriod && selectedPeriod.id === period.id) {
                                            setSelectedPeriod(null)
                                        } else {
                                            setSelectedPeriod(period)
                                        }
                                    }}
                                >
                                    <td>{period.policy.type_id === 1 ? trans('labels.policyByPoints') : trans('labels.policyByReservations')}</td>
                                    <td>{period.from_dmy}</td>
                                    <td>{period.to_dmy}</td>
                                    <td>{`${period.policy.repeat_after} ${getRepeatPeriod(period.policy.repeat_period, period.policy.repeat_after)}`}</td>
                                    <td className="options">
                                        <Options
                                            id={period.policy_id}
                                            handleEdit={handleEdit}
                                            handleDelete={handleDelete}
                                            handleShowResult={handleShowPeriods}
                                        />
                                    </td>
                                </tr>
                                <tr
                                    className={['collapsable', 'unclickable', period.id === selected ? 'active' : ''].join(' ')}
                                    data-row={period.id}
                                >
                                    {selectedPeriod &&
                                        <td colSpan="5">
                                            {((selectedPeriod.policy && selectedPeriod.policy.type_id === 1) || selectedPeriod.type_id === 1) ? (
                                                <table className='unclickable'>
                                                    <thead>
                                                        <tr>
                                                            <th>{trans('labels.user')}</th>
                                                            <th>{trans('labels.reservations')}</th>
                                                            <th>{trans('labels.pointsFromRules') || 'Points (Rules)'}</th>
                                                            <th>{trans('labels.pointsFromCustomers') || 'Points (Customers)'}</th>
                                                            <th>{trans('labels.delays')}</th>
                                                            <th>{trans('labels.reclamations')}</th>
                                                            <th>{trans('labels.progress')}</th>
                                                            <th>{trans('labels.completionForecast')}</th>
                                                            <th className="right">{trans('labels.bonus')}</th>
                                                            <th className="right">{trans('labels.super_bonus')}</th>
                                                            <th className="right">{trans('labels.total_earned_bonuses')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loading ? (
                                                            <tr>
                                                                <td colSpan="11">
                                                                    <Skeleton height={45} count={5} />
                                                                </td>
                                                            </tr>
                                                        ) : rows.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="11">
                                                                    <NoDataFound />
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            rows.map((row, idx) => (
                                                                <tr
                                                                    key={row.employee_id || idx}
                                                                    style={row.completed_target ? { backgroundColor: '#e6f9ed' } : {}}
                                                                >
                                                                    <td>
                                                                        <Box display="flex" alignItems="center" gap={1}>
                                                                            <Avatar style={{ width: 28, height: 28, marginRight: 8 }} />
                                                                            <span>{row.employee_name}</span>
                                                                        </Box>
                                                                    </td>
                                                                    <td>{row.total_reservations}</td>
                                                                    <td>{typeof row.points_from_rules !== 'undefined' ? row.points_from_rules : (typeof row.pointsFromRules !== 'undefined' ? row.pointsFromRules : 0)}</td>
                                                                    <td>{typeof row.points_from_customers !== 'undefined' ? row.points_from_customers : (typeof row.pointsFromCustomers !== 'undefined' ? row.pointsFromCustomers : 0)}</td>
                                                                    <td>{row.not_on_time_count}</td>
                                                                    <td>{row.reclamations_count}</td>
                                                                    <td style={{ minWidth: 200 }}>
                                                                        <Box display="flex" alignItems="center" gap={1}>
                                                                            <Box width="100%" mr={1}>
                                                                                <LinearProgress
                                                                                    variant="determinate"
                                                                                    value={row.progress_percentage}
                                                                                    sx={{
                                                                                        height: 12,
                                                                                        borderRadius: 20,
                                                                                        background: '#E7ECFF',
                                                                                        '& .MuiLinearProgress-bar': {
                                                                                            background: 'linear-gradient(90deg, #96D6BF 0%, #35B084 100%)',
                                                                                            borderRadius: 20
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </Box>
                                                                        </Box>
                                                                    </td>
                                                                    <td>
                                                                        <b>{row.estimated_completion_date ?? '-'}</b>
                                                                    </td>
                                                                    <td className="right">
                                                                        <b style={{ color: row.completed_target ? '#43b97f' : undefined }}>{`${row.total_earned_bonuses || '0.00'} ${row.currency?.name || 'EUR'}`}</b>
                                                                    </td>
                                                                    <td className="right">
                                                                        <b style={{ color: row.completed_target ? '#43b97f' : undefined }}>{`${row.super_bonus || '0.00'} ${row.currency?.name || 'EUR'}`}</b>
                                                                    </td>
                                                                    <td className="right">
                                                                        <b style={{ color: row.completed_target ? '#43b97f' : undefined }}>{`${row.total_earned_bonuses || '0.00'} ${row.currency?.name || 'EUR'}`}</b>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <table className='unclickable'>
                                                    <thead>
                                                        <tr>
                                                            <th>{trans('labels.user')}</th>
                                                            <th>{trans('labels.reservations')}</th>
                                                            <th>{trans('labels.delays')}</th>
                                                            <th>{trans('labels.reclamations')}</th>
                                                            <th>{trans('labels.progress')}</th>
                                                            <th>{trans('labels.completionForecast')}</th>
                                                            <th className="right">{trans('labels.bonus')}</th>
                                                            <th className="right">{trans('labels.super_bonus')}</th>
                                                            <th className="right">{trans('labels.total_earned_bonuses')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {loading ? (
                                                            <tr>
                                                                <td colSpan="9" align="center">
                                                                    <Skeleton height={45} count={5} />
                                                                </td>
                                                            </tr>
                                                        ) : rows.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="9" align="center">
                                                                    <NoDataFound />
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            rows.map((row, idx) => (
                                                                <tr
                                                                    key={row.employee_id || idx}
                                                                    style={row.completed_target ? { backgroundColor: '#e6f9ed' } : {}}
                                                                >
                                                                    <td>
                                                                        <Box display="flex" alignItems="center" gap={1}>
                                                                            <Avatar style={{ width: 28, height: 28, marginRight: 8 }} />
                                                                            <span>{row.employee_name}</span>
                                                                        </Box>
                                                                    </td>
                                                                    <td>{row.total_reservations}</td>
                                                                    <td>{row.not_on_time_count}</td>
                                                                    <td>{row.reclamations_count}</td>
                                                                    <td style={{ minWidth: 200 }}>
                                                                        <Box display="flex" alignItems="center" gap={1}>
                                                                            <Box width="100%" mr={1}>
                                                                                <LinearProgress
                                                                                    variant="determinate"
                                                                                    value={row.progress_percentage}
                                                                                    sx={{
                                                                                        height: 12,
                                                                                        borderRadius: 20,
                                                                                        background: '#E7ECFF',
                                                                                        '& .MuiLinearProgress-bar': {
                                                                                            background: 'linear-gradient(90deg, #96D6BF 0%, #35B084 100%)',
                                                                                            borderRadius: 20
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </Box>
                                                                        </Box>
                                                                    </td>
                                                                    <td>
                                                                        <b>{row.estimated_completion_date ?? '-'}</b>
                                                                    </td>
                                                                    <td className="right">
                                                                        <b style={{ color: row.completed_target ? '#43b97f' : undefined }}>{`${row.reward || '0.00'} ${row.currency?.name || 'EUR'}`}</b>
                                                                    </td>
                                                                    <td className="right">
                                                                        <b style={{ color: row.completed_target ? '#43b97f' : undefined }}>{`${row.super_bonus || '0.00'} ${row.currency?.name || 'EUR'}`}</b>
                                                                    </td>
                                                                    <td className="right">
                                                                        <b style={{ color: row.completed_target ? '#43b97f' : undefined }}>{`${row.total_earned_bonuses || '0.00'} ${row.currency?.name || 'EUR'}`}</b>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            )}
                                        </td>
                                    }
                                </tr>
                            </Fragment>
                        ))}
                    </tbody >
                </table >
            )
            }
        </>
    )
}

export default BonusPolicyTypesTab
